import React, { useEffect, useState } from "react";
import { useNotification } from "../Notification/NotificationContext";
import { useWorkshop } from "../Common/WorkshopContext";
import Pagination from "../Pagination/Pagination";
import {fetchLoyaltyCardsList, getInventoryForWorkshop} from "../../Api/Api";

const LoyaltyCardPage = () => {
    const { showNotification } = useNotification();
    const { workshopId } = useWorkshop();

    const [cards, setCards] = useState([]);
    const [loading, setLoading] = useState(false);
    const [statusFilter, setStatusFilter] = useState("ALL");
    const [currentPage, setCurrentPage] = useState(0);
    const [totalPages, setTotalPages] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const pageSize = 10;

    const fetchCards = async () => {
        setLoading(true);
        fetchLoyaltyCardsList(workshopId, currentPage, pageSize, statusFilter)
            .then((response) => {
                setCards(response.data.content);
                setTotalPages(response.data.totalPages);
                setTotalCount(response.data.totalElements);
            })
            .catch((err) =>  showNotification(err.message, "error"));
        setLoading(false);
    };

    const formatDate = (dateStr) => {
        if (!dateStr) return "-";
        const date = new Date(dateStr);
        return date.toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
        });
    };

    useEffect(() => {
        fetchCards();
    }, [statusFilter, currentPage, workshopId]);

    return (
        <div className="mt-6 max-w-screen-xl mx-auto">
            <div className="bg-white shadow-lg rounded-lg">
                <div className="bg-teal-400 text-white p-4 flex flex-col sm:flex-row justify-between items-center gap-4 rounded-t-lg">
                    <h2 className="text-xl font-semibold">Loyalty Cards</h2>
                    <div className="flex gap-2 items-center">
                        <select
                            value={statusFilter}
                            onChange={(e) => {
                                setStatusFilter(e.target.value);
                                setCurrentPage(0);
                            }}
                            className="px-4 py-2 rounded-md text-gray-700"
                        >
                            <option value="ALL">All</option>
                            <option value="ACTIVE">Active</option>
                            <option value="EXPIRED">Expired</option>
                        </select>
                    </div>
                </div>

                <div className="p-6">
                    {loading ? (
                        <div className="flex justify-center items-center">
                            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-teal-400"></div>
                        </div>
                    ) : (
                        <>
                            <div className="overflow-x-auto shadow-md rounded-lg">
                                <table className="min-w-full bg-white">
                                    <thead className="bg-gray-50 text-gray-800">
                                    <tr>
                                        <th className="p-3 text-left">Customer</th>
                                        <th className="p-3 text-left">Phone</th>
                                        <th className="p-3 text-left">Card Type</th>
                                        <th className="p-3 text-left">Status</th>
                                        <th className="p-3 text-left">Start</th>
                                        <th className="p-3 text-left">Expiry</th>
                                        <th className="p-3 text-left">Renew Count</th>
                                        <th className="p-3 text-left">Points</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {cards.map((card) => (
                                        <tr key={card.id} className="border-b hover:bg-gray-100">
                                            <td className="p-3">{card.customerName}</td>
                                            <td className="p-3">{card.customerPhone}</td>
                                            <td className="p-3">{card.cardType}</td>
                                            <td className="p-3">{card.status}</td>
                                            <td className="p-3">{formatDate(card.startDate)}</td>
                                            <td className="p-3">{formatDate(card.expiryDate)}</td>
                                            <td className="p-3">{card.renewCount}</td>
                                            <td className="p-3">{card.loyaltyPointsBalance}</td>
                                        </tr>
                                    ))}
                                    </tbody>
                                </table>
                            </div>
                            <div className="flex justify-start mt-2">
                                <Pagination
                                    totalPages={totalPages}
                                    onPageChange={setCurrentPage}
                                    currentPage={currentPage}
                                    totalCount={totalCount}
                                />
                            </div>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default LoyaltyCardPage;
